export const COMPLAINT_CATEGORIES = "/complaint-category/";
export const COMPLAINT_CATEGORY = (id) => `/complaint-category/${id}`;
export const COMPLAINT_CATEGORY_VERTICALS = "/complaint-category/verticals";
